import { render, staticRenderFns } from "./partnerSettlement.vue?vue&type=template&id=784b9bf6&"
import script from "./partnerSettlement.vue?vue&type=script&lang=js&"
export * from "./partnerSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports